import { padEnd, toUpper } from "lodash";
import { StringUtil, BrandUtil } from "../../utils";
import { BUSINESS_UNIT } from "../../constants";
const {
  REACT_APP_FIREBASE_DPD_EMAIL = "@dpd.dpduk.live",
  REACT_APP_FIREBASE_DPDLOCAL_EMAIL = "@dpdlocal.dpduk.live"
} = process.env;
const PAD_CHARACTER = String.fromCharCode(253);
const MIN_PASSWORD_LENGTH = 6;
export const formatCredentials = (credentials, carrier = BUSINESS_UNIT.DPD) => {
  if (StringUtil.isEmail(credentials.username)) {
    return credentials;
  }

  credentials.password = toUpper(credentials.password);

  if (credentials?.password?.length < MIN_PASSWORD_LENGTH) {
    credentials.password = padEnd(credentials.password, MIN_PASSWORD_LENGTH, PAD_CHARACTER);
  }

  const isCarrierLocal = carrier === BUSINESS_UNIT.DPD_LOCAL || BrandUtil.isDpdLocalDomain();
  credentials.username = `${encodeURIComponent(credentials.username)}${isCarrierLocal ? REACT_APP_FIREBASE_DPDLOCAL_EMAIL : REACT_APP_FIREBASE_DPD_EMAIL}`;
  return credentials;
};